// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__EDuSI","messages":"Chat_messages__rOdi8","dateDivider":"Chat_dateDivider__20nWR"};